import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistReducer, persistStore,
  FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { useSelector } from 'react-redux';
import businessReducer from './reducers/businessReducer';
import bookingReducer from './reducers/bookingReducer';

const rootReducer = combineReducers({
  businessStore: businessReducer,
  bookingStore: bookingReducer,
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistor = persistStore(store);
export type RootState = ReturnType<typeof rootReducer>;

export { store, persistor };


export const useSelectBusinesses = () => {
  return useSelector((state: RootState) => state.businessStore.businesses);
};

export const useSelectBookings = () => {
  return useSelector((state: RootState) => { return state.bookingStore.getBookings });
};


export const useSelectedBusiness = () => {
  const { businesses, selectedBusiness } = useSelector(
    (state: RootState) => state.businessStore
  );
  return (
    businesses.find(
      (b) =>
        Number(b.businessBasic.id) ===
        Number(selectedBusiness?.businessBasic?.id)
    ) || null
  );
};
